export default __webpack_public_path__ + "static/media/Handle_DHP306.c3836daa.obj";